module.exports = __webpack_public_path__ + "img/kaideLOGO.443f23e5.png";